export default {
    wblcategory: {
        columnlist: "Column List",
        create: "Create your White Black List Category",
        name: "Name",
        targettable: "Target Table",
        title: "White/Black List Category",
        update: "Update your White Black List Category",
        choose_columnlist: "Choose Column List"
      }
}